import React, { useEffect } from 'react'

export const useIntersectionObserver = (ref, callback, dependencies = [], options = { threshold: 0.5 }) => {
  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry?.isIntersecting) callback()
    }, options)

    if (ref.current) {
      observer.observe(ref.current)
    }

    return () => {
      if (ref.current) {
        observer.unobserve(ref.current)
      }
    }
  }, [callback, ...dependencies])
}
